import PropTypes from "prop-types";
import { styled } from "styled-components";

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY};
  border-radius: 5px;
  max-width: 93px;
`;

const ProgressFill = styled.div`
  background-color: ${({ theme }) => theme.COLORS.PRIMARY};
  height: 100%;
  margin: 0;
  border-radius: 5px;
  width: ${({ progress }) => `${progress}%`};
  transition: width 0.3s;
`;

const Progress = ({ progress }) => (
  <ProgressBar>
    <ProgressFill progress={progress} />
  </ProgressBar>
);

Progress.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default Progress;
